import { useState, useEffect } from "react";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => { if (!localStorage.getItem("certy_cookies")) setShow(true); }, []);
  if (!show) return null;
  const accept = (v) => { localStorage.setItem("certy_cookies", v); setShow(false); };
  return (
    <div data-testid="cookie-banner" className="no-print fixed bottom-0 inset-x-0 z-50 p-3 sm:p-4">
      <div className="max-w-3xl mx-auto bg-navy text-white rounded-2xl shadow-2xl p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-3">
        <p className="text-sm leading-relaxed flex-1">
          We use essential cookies to keep you signed in and improve GetCerty. See our{" "}
          <a href="/legal/cookies" className="underline text-emerald-glow">cookie policy</a>.
        </p>
        <div className="flex gap-2">
          <button data-testid="cookie-reject" onClick={() => accept("essential")}
            className="min-h-[44px] px-4 rounded-xl bg-white/10 hover:bg-white/20 text-sm font-medium transition-colors">
            Essential only
          </button>
          <button data-testid="cookie-accept" onClick={() => accept("all")}
            className="min-h-[44px] px-4 rounded-xl bg-emerald-brand hover:bg-emerald-deep text-sm font-semibold transition-colors">
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
}
